import React, { useState } from "react";

import { Button, Form, Input, message, Select, TreeSelect } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { SPEND_PART } from "../../../../redux/modules/Parts/actions";
import { GET_ORDER_SUCCESS } from "../../../../redux/modules/Maintenances/actions";
import PartsSearch from "../../../../components/PartsSearch";
import { newNestedSorting } from "../../../../helpers/functions";

const SpendForm = ({ work_order, close, _part }) => {
  const [part, set_part] = useState(_part);


  const dispatch = useDispatch();
  const { spendPart } = useSelector((state) => state.partsReducer);

  const [location, set_location] = useState(null);
  const [quantity, set_quantity] = useState(null);
  const [locations, set_locations] = useState([]);
  const [note, set_note] = useState("");

  const { order } = useSelector((state) => state.maintenanceReducer);

  const onSpend = () => {
    if (!+quantity || !quantity || !location || !part) {
      message.warn("Sva polja su obavezna");
      return;
    }

    dispatch({
      type: SPEND_PART,
      data: {
        work_order: work_order,
        part: part[0],
        location,
        qty: +quantity,
        note,
      },
      errorCallback: () => {
        message.error("Dogodila se greška.");
      },
      successCallback: (data) => {
        if(order.data.parts){
          const arr = [...order.data.parts];
          arr.push(data.data);
          dispatch({
            type: GET_ORDER_SUCCESS,
            data: { ...order.data, parts: arr },
          });
        }
      
        close();
      },
    });
  };

  return (
    <div
      style={{
        height: 369,
        display: "flex",
        justifyContent: "space-between",
        alignContent: "center",
        flexDirection: "column",
        // maxWidth: 400 ,
      }}
    >
      <div>
        <span>Dio</span>
        <div>
          <PartsSearch
            onChange={(id, object) => {
              set_part(id);
              set_locations(object?.part_storage?.map((x) => x.storage) || []);
            }}
          />
        </div>
      </div>
      <div>
        <span>Skladište</span>
        <div>
          <TreeSelect
            style={{ width: "100%" }}
            allowClear={true}
            multiple={false}
            treeData={newNestedSorting(locations)}
            onSelect={set_location}
            showSearch
            optionFilterProp="name"
            filterTreeNode={(input, option) => {
              return (
                option.props.name.toLowerCase().indexOf(input.toLowerCase()) >=
                0
              );
            }}
          />
        </div>
      </div>

      <div>
        <span>Količina</span>
        <Input onChange={({ target: { value } }) => set_quantity(value)} />
      </div>

      <div>
        <span>Napomena</span>
        <Input.TextArea
          rows={3}
          onChange={({ target: { value } }) => set_note(value)}
        />
      </div>

      <Button loading={spendPart.status === "loading"} onClick={() => {
        if(!quantity || !location || !part){
          message.warning("Unesite polja.");
          return;
        }
        onSpend();
      }}>
        Spremi
      </Button>
    </div>
  );
};

export default SpendForm;
